import React from 'react';
import { WidgetContainer } from '../Widgets';

const StubHealthcallWidget = (props) => {
  const { acctMember } = props;
  return (
    <WidgetContainer
      widgetName="healthcall_patient"
      widgetProps={{
        accountMember: acctMember,
      }}
      style={{
        width: '98%',
        marginTop: '10px',
        marginBottom: '20px',
      }}
      autoFullHeight={true}
    />
  );
};

const HealthcallWidget = (props) => {
  const { idnData } = props;

  return <StubHealthcallWidget acctMember={idnData.idnDoc.aa[0]} />;
};

export default HealthcallWidget;
